export const NavItemEnum = {
  ADD_ONS: 'add-ons',
  HUBSPOT_CREDITS: 'hubspot-credits',
  BUNDLE: 'bundle',
  COMMERCE: 'commerce',
  CONTENT: 'content',
  FREE: 'crm',
  MARKETING: 'marketing',
  MARKETING_PLUS: 'marketing-plus',
  DATA: 'data',
  SALES: 'sales',
  SERVICE: 'service',
  SMART_CRM: 'smart-crm',
  SUITE: 'suite'
};
export const NavSectionEnum = {
  BUNDLE: 'bundle',
  CORE: 'core',
  ENHANCEMENTS: 'enhancements'
};
export const SegmentedNavItems = {
  [NavSectionEnum.BUNDLE]: [NavItemEnum.SUITE, NavItemEnum.FREE, NavItemEnum.BUNDLE, NavItemEnum.MARKETING_PLUS],
  [NavSectionEnum.CORE]: [NavItemEnum.SMART_CRM, NavItemEnum.MARKETING, NavItemEnum.SALES, NavItemEnum.SERVICE, NavItemEnum.CONTENT, NavItemEnum.DATA, NavItemEnum.COMMERCE],
  [NavSectionEnum.ENHANCEMENTS]: [NavItemEnum.HUBSPOT_CREDITS, NavItemEnum.ADD_ONS]
};
export const CreditsPageNavItemTabs = [NavItemEnum.SUITE, NavItemEnum.MARKETING, NavItemEnum.SALES, NavItemEnum.SERVICE, NavItemEnum.CONTENT, NavItemEnum.DATA, NavItemEnum.COMMERCE];
export function isCreditsPageNavItemTab(item) {
  return CreditsPageNavItemTabs.includes(item);
}